export default __webpack_public_path__ + "static/media/small.5ff31b4e.jpg";